<!-- 客户、供应商、物流公司建账 -->
<template>
    <div v-loading="loading" class="builda-infoes">
        <el-form :rules="rules" :model="submitData" label-width="80px" ref="submitData">
            <el-form-item :label="CType == 0 ? '客户' : CType == 1 ? '供应商' : '物流公司'" prop="EntpCusId">
                <el-select
                    size="small"
                    v-model="submitData.EntpCusId"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    :remote-method="querySearch"
                    v-select-scroll-more="searchLoad"
                    style="width: 100%"
                >
                    <el-option v-for="optionItem in cusOptions" :key="optionItem.EntpCusId" :data-msg="optionItem" :label="optionItem.EntpCusName" :value="optionItem.EntpCusId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="IsEdit" label="原金额" prop="TotalAmount">
                <el-input size="small" type="number" disabled v-model="CurrentData.TotalAmount" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item v-if="IsEdit" :label="CType == 1 ? '已付金额' : '已收金额'" prop="AlreadyPaid">
                <el-input size="small" type="number" disabled v-model="CurrentData.AlreadyPaid" style="width: 100%"></el-input>
            </el-form-item>
             <el-form-item label="发生日期" prop="PayDate">
                <el-date-picker style="width: 100%" size="small" v-model="submitData.PayDate" align="right" type="date" placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="发生额" prop="CollectionAmount">
                <el-input size="small" type="number" step="0.01" v-model="submitData.CollectionAmount" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input size="small" v-model="submitData.Remark" style="width: 100%"></el-input>
            </el-form-item>
        </el-form>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn" @click="cancel()">取消</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="submitForm()">提交</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['CurrentData', 'CType', 'IsEdit'],
    components: {},
    data() {
        return {
            loading: false,
            payWayList: [],
            submitData: {
                CollectionAmount: 0,
                EntpCusId: '',
                Remark: '',
                CType: 0,
                RecordId: '',
                PayDate: ''
            },
            rules: {
                EntpCusId: [{ required: true, message: '该项必选', trigger: 'change' }],
                PayDate: [{ required: true, message: '该项必选', trigger: 'change' }],
                CollectionAmount: [{ required: true, message: '该项必填', trigger: 'change' }]
            },
            tableData: [],
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    created(){
         //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);

        this.submitData.PayDate = date1;
    },
    mounted() {
        if (this.CType !== null && this.CType !== undefined) {
            this.submitData.CType = this.CType;
        } else {
            this.$util.warningMsg('建账实体信息异常，请刷新后重新操作');
            return;
        }
        this.querySearch();

        if (this.CurrentData && this.CurrentData.EntpCusId) {
            this.submitData.EntpCusId = this.CurrentData.EntpCusId;

            if (this.IsEdit) {
                this.submitData.RecordId = this.CurrentData.RecordId;
                this.submitData.CollectionAmount = this.CurrentData.TotalAmount;
                this.submitData.Remark = this.CurrentData.Remark;
                this.submitData.PayDate = this.CurrentData.PayTime;
            }

            if (this.CurrentData.EntpCusName) {
                let idx = this.cusOptions.findIndex(f => f.EntpCusId == this.CurrentData.EntpCusId);
                if (idx === -1) {
                    this.cusOptions.push({
                        EntpCusId: this.CurrentData.EntpCusId,
                        EntpCusName: this.CurrentData.EntpCusName
                    });
                }
            }
        }
    },
    methods: {
        cancel() {
            this.$emit('closeDialog');
        },
        submitForm() {
            if (this.submitData.CollectionAmount == 0) {
                this.$util.warningMsg('建账金额不能等于0');
                return;
            }
            this.$confirm(this.IsEdit ? '您确定要修改该条账款吗？' : '您确认要提交建账吗？', '提示', {
                confirmButtonText: this.IsEdit ? '确定修改' : '确定建账',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            })
                .then(() => {
                    this.$refs['submitData'].validate(valid => {
                        if (valid) {
                            this.loading = true;
                            this.$util
                                .axiosPost({
                                    url: '/api/RevenueManagement_H/BuildAccountRecords',
                                    data: this.submitData,
                                    hideLoading: true
                                })
                                .then(res => {
                                    if (this.IsEdit) this.$util.successMsg('修改成功');
                                    else this.$util.successMsg('建账成功');
                                    this.submitData.CollectionAmount = 0;
                                    this.submitData.Remark = '';
                                    this.submitData.RecordId = '';
                                    this.$emit('closeDialog', true);
                                })
                                .finally(() => {
                                    this.loading = false;
                                });
                        } else {
                            return false;
                        }
                    });
                })
                .catch(() => {});
        },
        async querySearch(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            let data = {};
            switch (this.CType) {
                case 0:
                    data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
                    break;
                case 1:
                    data = await this.$util.searchSupplier(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
                    break;
                case 2:
                    data = await this.$util.searchLogistic(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
                    break;
                default:
                    this.$util.warningMsg('建账实体信息异常，请刷新后重新操作');
                    return;
            }
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                if(this.cusForm.Page == 1)
                    this.cusOptions=data;
                else
                    this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchLoad() {
            this.cusForm.Page += 1;
            this.querySearch();
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}
.btn-ctn {
    text-align: right;
}
.builda-infoes {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 340px;
    height: auto;

    .dialog-footer {
        text-align: right;
    }
    .el-form-item {
        margin-bottom: 0;
    }
}
</style>
